export function LoadingScreen() {
  return (
    <div className="loading-screen" role="status" aria-label="Opening your workspace">
      <div className="loading-mark"><span /></div>
      <p>Opening your private workspace…</p>
    </div>
  );
}

